import { Injectable, inject } from "@angular/core";
import {url_routes} from "../core.routes";
import { HttpClient } from "@angular/common/http";
import {SearchRequest} from "../model/search/SearchRequest";
import {SearchRecord} from "../model/search/SearchRecord";

@Injectable()
export class SearchService {
    private http = inject(HttpClient);


    searchUrl = url_routes.SEARCH;

    search(searchText: string): Promise<SearchRecord[]> {
        let searchRequest = new SearchRequest();
        searchRequest.searchText = searchText;
        return this.http.post(this.searchUrl, searchRequest).toPromise().then();
    }
}
